export default __webpack_public_path__ + "static/media/pre-verified30.5d64205f.png";